export function windowsRise(window, func) {
    window.onresize = () => {
        return (() => {
            typeof func == "function" && func();
        })()
    }
}
